/**
 * Mock data for local development when API requires authentication
 * This allows UI development without needing Google Workspace auth
 */

import type { DirectoryEntry, Facets, Branding, User } from '../types/api';

export const mockDirectoryEntries: DirectoryEntry[] = [
  {
    id: 'mock-1',
    name: 'Sunset Surgery Center',
    url: 'https://example.com/ssc',
    categories: ['ASC', 'Surgery'],
    team: 'Operations',
    description: 'Main surgery center location',
    accessEmails: ['dev@example.com'],
  },
  {
    id: 'mock-2',
    name: 'Employee Portal',
    url: 'https://example.com/portal',
    categories: ['HR', 'Internal'],
    team: 'All Staff',
    description: 'Employee self-service portal',
    accessEmails: ['dev@example.com'],
  },
  {
    id: 'mock-3',
    name: 'Training Hub',
    url: 'https://example.com/training',
    categories: ['Education', 'Compliance'],
    team: 'Clinical',
    description: 'Online training and certification tracking',
    accessEmails: ['dev@example.com'],
  },
  {
    id: 'mock-4',
    name: 'Supply Ordering',
    url: 'https://example.com/supplies',
    categories: ['Operations', 'Purchasing'],
    team: 'Materials Management',
    description: 'Medical and office supply ordering system',
    accessEmails: ['dev@example.com'],
  },
  {
    id: 'mock-5',
    name: 'Quality Dashboard',
    url: 'https://example.com/quality',
    categories: ['Quality', 'Reporting'],
    team: 'Quality Assurance',
    description: 'Quality metrics and reporting dashboard',
    accessEmails: ['dev@example.com'],
  },
];

export const mockFacets: Facets = {
  total: mockDirectoryEntries.length,
  teams: [
    { name: 'All Staff', count: 1 },
    { name: 'Operations', count: 1 },
    { name: 'Clinical', count: 1 },
    { name: 'Materials Management', count: 1 },
    { name: 'Quality Assurance', count: 1 },
  ],
  categories: [
    { name: 'ASC', count: 1 },
    { name: 'Surgery', count: 1 },
    { name: 'HR', count: 1 },
    { name: 'Internal', count: 1 },
    { name: 'Education', count: 1 },
    { name: 'Compliance', count: 1 },
    { name: 'Operations', count: 1 },
    { name: 'Purchasing', count: 1 },
    { name: 'Quality', count: 1 },
    { name: 'Reporting', count: 1 },
  ],
};

export const mockBranding: Branding = {
  title: 'Southern Skies Dermatology & Surgery Intranet',
  logoUrl: '/ssd-logo.png',
};

export const mockUser: User = {
  email: 'dev@example.com',
  isAuthenticated: true,
};

/**
 * Check if we should use mock data
 * Uses mock data when proxy returns authentication error
 */
export function shouldUseMockData(): boolean {
  // In development, default to mock data if env var is set
  if (import.meta.env.VITE_USE_MOCK_DATA === 'true') {
    return true;
  }
  return false;
}
